// extracted by mini-css-extract-plugin
export var blink = "HorizontalList-module--blink--c1295";
export var gradient = "HorizontalList-module--gradient--95392";
export var list = "HorizontalList-module--list--ced48";
export var spin = "HorizontalList-module--spin--c3898";